import type { FaireProductEntity } from "../../entity_types/product";

export const p_baztwggcve: FaireProductEntity = {
  token: "p_baztwggcve",
  type: "product",
  name: "Striped Pattern Mock Neck Open Front Long Sleeve Blazer",
  brandToken: "b_9rvhvqmmsv",
  brandName: "The Moment Collection",
  imageUrl:
    "https://cdn.faire.com/fastly/98bf7d2bdcf94e98743321a2bed2c7825871af872281a7cbc373bd3b8da3fa3b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2a283bd9b23956357ade79ff4d0280dc54a59664be2a540b41c13679a12eb57a.jpeg",
    "https://cdn.faire.com/fastly/75fc93837ab08961f1df65cf99ca0e55ee1d34c2a3324cffbe91aea9696f65c1.jpeg",
    "https://cdn.faire.com/fastly/5a0fc5952543d3d187d71f907488bb5f53d2367a300a8619025d455a6fccd7d3.jpeg",
    "https://cdn.faire.com/fastly/e6e18c12ea43ff3bc966d5f30bf137d16ddc8f66afccbef748a92d60e3655502.jpeg",
    "https://cdn.faire.com/fastly/5d6f04f23f52ad52fb5ce90bada47dcf320eca0b43b23c43f24355071dfdc6ad.jpeg",
    "https://cdn.faire.com/fastly/6b6abfaa83459955272b62ed8e24ef722f9bc619f69db6b5841eea1d2bdd98c1.jpeg",
    "https://cdn.faire.com/fastly/1759bde117735797d723bea0d9464fe86dfbdea7f60d4465a3c6994f2866a5b6.jpeg",
  ],
  priceDollars: 26.7,
  description:
    "*FEATURES: Mid-Weight/Mock Neck/Open Front/Decorative Pockets/Fitted Bodice/No Pockets\n*COLOR:  KHAKI/GREY/BLACK/PLUM\n*SIZE: S/M/L/XL\n*STYLE: 70047\n*Support individual sizes and individual pieces.\n*2-5 days processing time.\n*Made in China.\n*Due to the style differences, please check out the last image for the size chart of this style.",
  tags: [],
  msrpDollars: 53.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:29.404Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
